"use strict";
'kiwi public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));
var _GlobalApi = _interopRequireDefault(require("@/libs/GlobalApi"));
var _Html = _interopRequireDefault(require("@/libs/renderers/Html"));
var _MessageParser = _interopRequireDefault(require("@/libs/MessageParser"));
var _BufferSettings = _interopRequireDefault(require("./BufferSettings"));
var _ChannelInfo = _interopRequireDefault(require("./ChannelInfo"));
var _ChannelBanlist = _interopRequireDefault(require("./ChannelBanlist"));
var _AwayStatusIndicator = _interopRequireDefault(require("./AwayStatusIndicator"));
var _default = exports.default = {
  components: {
    BufferSettings: _BufferSettings.default,
    ChannelInfo: _ChannelInfo.default,
    ChannelBanlist: _ChannelBanlist.default,
    AwayStatusIndicator: _AwayStatusIndicator.default
  },
  props: ['buffer', 'sidebarState'],
  data: function data() {
    return {
      self: this,
      showQuerySwitcher: false,
      pluginUiChannelElements: _GlobalApi.default.singleton().channelHeaderPlugins,
      pluginUiQueryElements: _GlobalApi.default.singleton().queryHeaderPlugins
    };
  },
  watch: {
    buffer: {
      immediate: true,
      handler: function handler(buffer) {
        this.rememberLastChannel(buffer);
      }
    }
  },
  computed: {
    isJoined: function isJoined() {
      var buffer = this.buffer;
      return buffer.getNetwork().state === 'connected' && buffer.joined;
    },
    isConnected: function isConnected() {
      return this.buffer.getNetwork().state === 'connected';
    },
    shouldShowTopic: function shouldShowTopic() {
      var _context;
      return !this.$state.ui.is_narrow && (0, _trim.default)(_context = this.buffer.topic).call(_context) && this.buffer.setting('show_topic_in_header');
    },
    formattedTopic: function formattedTopic() {
      var blocks = (0, _MessageParser.default)(this.buffer.topic, {
        extras: false
      });
      var content = (0, _Html.default)(blocks);
      return content;
    },
    network: function network() {
      return this.buffer.getNetwork();
    },
    serverHeaderName: function serverHeaderName() {
      return this.buffer.active_tab === 'channels' ? 'Listado de salas' : this.buffer.getNetwork().name;
    },
    sidebarSection: function sidebarSection() {
      return this.sidebarState.section();
    },
    userOnline: function userOnline() {
      var user = this.$state.getUser(this.buffer.getNetwork().id, this.buffer.name);
      return !!user;
    },
    areWeAnOp: function areWeAnOp() {
      return this.buffer.isChannel() && this.buffer.isUserAnOp(this.buffer.getNetwork().nick);
    },
    queryBuffers: function queryBuffers() {
      var network = this.buffer.getNetwork();
      var buffers = Array.isArray(network.buffers) ? network.buffers : [];
      return (0, _filter.default)(buffers).call(buffers, function (buffer) {
        return buffer && buffer.isQuery && buffer.isQuery();
      });
    }
  },
  methods: {
    isChannel: function isChannel() {
      return this.buffer.isChannel();
    },
    isServer: function isServer() {
      return this.buffer.isServer();
    },
    isQuery: function isQuery() {
      return this.buffer.isQuery();
    },
    isSpecial: function isSpecial() {
      return this.buffer.isSpecial();
    },
    showNetworkSettings: function showNetworkSettings(network) {
      network.showServerBuffer('settings');
    },
    onConnectButtonClick: function onConnectButtonClick() {
      var network = this.buffer.getNetwork();
      if (!network.connection.server) {
        network.showServerBuffer('settings');
      } else {
        network.ircClient.connect();
      }
    },
    toggleUser: function toggleUser() {
      var user = this.$state.getUser(this.buffer.getNetwork().id, this.buffer.name);
      this.sidebarState.toggleUser(user);
    },
    unreadLabel: function unreadLabel(count) {
      return count > 999 ? '999+' : count;
    },
    toggleQuerySwitcher: function toggleQuerySwitcher() {
      this.showQuerySwitcher = !this.showQuerySwitcher;
    },
    openQueryBuffer: function openQueryBuffer(queryBuffer) {
      if (!queryBuffer) {
        return;
      }
      this.showQuerySwitcher = false;
      this.$state.setActiveBuffer(queryBuffer.networkid, queryBuffer.name);
      if (this.$state.ui.is_narrow && this.sidebarState && this.sidebarState.close) {
        this.sidebarState.close();
      }
    },
    returnToSafeBuffer: function returnToSafeBuffer(network, excludeBuffer) {
      var targetBuffer = null;
      var lastChannel = '';
      try {
        lastChannel = localStorage.getItem('chatlatinos_last_channel_' + network.id) || '';
      } catch (error) {
        lastChannel = '';
      }
      if (lastChannel) {
        targetBuffer = this.$state.getBufferByName(network.id, lastChannel);
      }
      if (!targetBuffer || targetBuffer === excludeBuffer || !targetBuffer.isChannel || !targetBuffer.isChannel()) {
        var buffers = Array.isArray(network.buffers) ? network.buffers : [];
        targetBuffer = (0, _find.default)(buffers).call(buffers, function (buffer) {
          return buffer && buffer !== excludeBuffer && buffer.isChannel && buffer.isChannel() && buffer.joined;
        });
      }
      if (!targetBuffer && network.serverBuffer) {
        targetBuffer = network.serverBuffer();
      }
      if (targetBuffer) {
        this.$state.setActiveBuffer(network.id, targetBuffer.name);
      }
    },
    closeSpecificQueryBuffer: function closeSpecificQueryBuffer(queryBuffer) {
      var _this = this;
      if (!queryBuffer || !queryBuffer.isQuery || !queryBuffer.isQuery()) {
        return;
      }
      var network = queryBuffer.getNetwork();
      var isActive = queryBuffer.networkid === this.$state.ui.active_network && queryBuffer.name === this.$state.ui.active_buffer;
      if (isActive) {
        this.returnToSafeBuffer(network, queryBuffer);
      }
      this.showQuerySwitcher = false;
      this.$nextTick(function () {
        _this.$state.removeBuffer(queryBuffer);
      });
    },
    closeQueryBuffer: function closeQueryBuffer() {
      this.closeSpecificQueryBuffer(this.buffer);
    },
    rememberLastChannel: function rememberLastChannel(buffer) {
      if (!buffer || !buffer.isChannel || !buffer.isChannel()) {
        return;
      }
      try {
        localStorage.setItem('chatlatinos_last_channel_' + buffer.getNetwork().id, buffer.name);
      } catch (error) {}
    },
    minimizeQueryBuffer: function minimizeQueryBuffer() {
      if (!this.buffer || !this.buffer.isQuery()) {
        return;
      }
      var network = this.buffer.getNetwork();
      var lastChannel = '';
      try {
        lastChannel = localStorage.getItem('chatlatinos_last_channel_' + network.id) || '';
      } catch (error) {
        lastChannel = '';
      }
      if (lastChannel && this.$state.getBufferByName(network.id, lastChannel)) {
        this.$state.setActiveBuffer(network.id, lastChannel);
        return;
      }
      var buffers = Array.isArray(network.buffers) ? network.buffers : [];
      var channelBuffer = (0, _find.default)(buffers).call(buffers, function (buffer) {
        return buffer && buffer.isChannel && buffer.isChannel() && buffer.joined;
      });
      if (channelBuffer) {
        this.$state.setActiveBuffer(network.id, channelBuffer.name);
        return;
      }
      if (network.serverBuffer) {
        var serverBuffer = network.serverBuffer();
        if (serverBuffer) {
          this.$state.setActiveBuffer(network.id, serverBuffer.name);
        }
      }
    },
    openOperatorTools: function openOperatorTools() {
      var _this2 = this;
      this.sidebarState.showBufferSettings();
      this.$nextTick(function () {
        _this2.$state.$emit('sidebar.settings.tab', 'operator');
      });
    },
    joinCurrentBuffer: function joinCurrentBuffer() {
      var network = this.buffer.getNetwork();
      this.buffer.enabled = true;
      network.ircClient.join(this.buffer.name);
    },
    onHeaderClick: function onHeaderClick(event) {
      var channelName = event.target.getAttribute('data-channel-name');
      if (channelName) {
        var network = this.buffer.getNetwork();
        this.$state.addBuffer(this.buffer.networkid, channelName);
        network.ircClient.join(channelName);
      }
    }
  }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["ContainerHeader"]
window._kiwi_exports.components.ContainerHeader = exports.default ? exports.default : exports;
